import { onBeforeMount, onBeforeUnmount } from 'vue'
import pubsub from '@/lib/pubsub'
import { hasValidUserSession } from '@/services/identity-client'

/**
 * *(AI-generated)*
 * Composable that publishes an app_foregrounded marketing event on mount and on window focus.
 */
export function useAppForegrounded() {
  const handleFocus = async () => {
    pubsub.publish('x-marketing-event', {
      name: 'app_foregrounded',
      is_authenticated: await hasValidUserSession(),
    })
  }

  onBeforeMount(() => {
    handleFocus()
    window.addEventListener('focus', handleFocus)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('focus', handleFocus)
  })
}
